import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, BookOpen, Plus, Minus, X, Divide, Trophy, ArrowLeft } from 'lucide-react';

const MASCOT_URL =
  'https://static.prod-images.emergentagent.com/jobs/0e7ec82b-be21-4167-ae09-299c58207254/images/74fa619aec3bc4f2ce6f55b0bc0a86dee551f7ad9bd9a596e5a33b7f45e9610e.png';

const operations = [
  { key: 'addition', label: 'Addition', icon: Plus, bg: 'bg-emerald-500', border: 'border-emerald-700' },
  { key: 'subtraction', label: 'Subtraction', icon: Minus, bg: 'bg-blue-500', border: 'border-blue-700' },
  { key: 'multiplication', label: 'Multiply', icon: X, bg: 'bg-purple-500', border: 'border-purple-700' },
  { key: 'division', label: 'Division', icon: Divide, bg: 'bg-red-500', border: 'border-red-700' },
];

const TIGER_URL =
  'https://static.prod-images.emergentagent.com/jobs/0e7ec82b-be21-4167-ae09-299c58207254/images/373bd01ec6b7a90828c049b451f3a62da5129c3889c93c961a074588bd3baacb.png';

export default function HomePage() {
  const navigate = useNavigate();
  const [showOps, setShowOps] = useState(false);

  const startTest = () => {
    navigate('/game?mode=test&operation=mixed');
  };

  const startPractice = (operation) => {
    navigate(`/game?mode=practice&operation=${operation}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 relative">

      {/* Ant Mascot */}
      <div className="mb-4 animate-bounce-slow">
        <div className="w-36 h-36 sm:w-44 sm:h-44 rounded-full overflow-hidden border-4 border-white shadow-xl bg-white">
          <img
            src={TIGER_URL}
            alt="Tiger mascot"
            className="w-full h-full object-cover"
            data-testid="tiger-mascot"
          />
        </div>
      </div>

      {/* Title */}
      <h1
        data-testid="app-title"
        className="mb-8 text-center text-black drop-shadow-md font-heading text-4xl sm:text-5xl lg:text-6xl font-black"
      >
        Jungle Math
      </h1>

      {!showOps ? (
        <div className="flex flex-col sm:flex-row gap-5 w-full max-w-md">
          <button
            data-testid="play-practice-mode"
            onClick={() => setShowOps(true)}
            className="flex-1 bg-emerald-500 text-white font-black text-xl py-5 px-8 rounded-full border-b-[6px] border-emerald-700 active:border-b-0 active:translate-y-[6px] transition-all hover:bg-emerald-400 flex items-center justify-center gap-3 shadow-lg"
          >
            <BookOpen className="w-7 h-7" />
            Practice
          </button>

          <button
            data-testid="play-test-mode"
            onClick={startTest}
            className="flex-1 bg-orange-500 text-white font-black text-xl py-5 px-8 rounded-full border-b-[6px] border-orange-700 active:border-b-0 active:translate-y-[6px] transition-all hover:bg-orange-400 flex items-center justify-center gap-3 shadow-lg"
          >
            <Clock className="w-7 h-7" />
            Test
          </button>
        </div>
      ) : (
        <div className="w-full max-w-lg">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-amber-950 text-center mb-5">
            Choose Your Challenge!
          </h2>
          <div className="grid grid-cols-2 gap-4">
            {operations.map((op) => (
              <button
                key={op.key}
                data-testid={`select-${op.key}`}
                onClick={() => startPractice(op.key)}
                className={`${op.bg} ${op.border} text-white font-black text-lg py-5 px-4 rounded-3xl border-b-[6px] active:border-b-0 active:translate-y-[6px] transition-all hover:opacity-90 flex flex-col items-center gap-2 shadow-lg`}
              >
                <op.icon className="w-10 h-10" strokeWidth={3} />
                {op.label}
              </button>
            ))}
          </div>
          <button
            data-testid="back-to-modes"
            onClick={() => setShowOps(false)}
            className="mt-5 mx-auto flex items-center gap-1 text-amber-800 font-bold text-lg hover:text-amber-950 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Back
          </button>
        </div>
      )}
    </div>
  );
}
